export default {
  colorScheme: {
    light: {
      root: {
        background: 'rgba(0,0,0,0.1)',
      },
    },
    dark: {
      root: {
        background: 'rgba(255,255,255,0.3)',
      },
    },
  },
};
